import { render, staticRenderFns } from "./OrderResults.vue?vue&type=template&id=59aed94a&scoped=true"
import script from "./OrderResults.vue?vue&type=script&lang=js"
export * from "./OrderResults.vue?vue&type=script&lang=js"
import style0 from "./OrderResults.vue?vue&type=style&index=0&id=59aed94a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "59aed94a",
  null
  
)

export default component.exports